export default __webpack_public_path__ + "static/media/sister-capiz.aacba441.png";